document.addEventListener('DOMContentLoaded', () => {
  const recEls = document.querySelectorAll('ubuntu-product-recommendations');

  recEls.forEach((el) => {
    const url = el.dataset.url;
    if (!url || el.dataset.handled === 'true') return;
    el.dataset.handled = 'true';

    console.log('🧩 Fetching complementary products from JSON:', url);

    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        console.log('📦 Got JSON data:', data);
        if (!data?.products?.length) {
          el.innerHTML = ` `;
          return;
        }


        el.innerHTML = `
  <aside aria-label="Complementary products" class="product__accordion accordion">
    <div class="complementary-products__container">
      <details id="Details-${el.dataset.sectionId || 'complementary'}" open>
        <summary>
          <div class="summary__title">
            <h2 class="h4 accordion__title">
              ${el.dataset.blockHeading || 'You may also like'}
            </h2>
          </div>
          <svg class="icon-caret" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L5 5L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </summary>
        <div class="accordion__content">
          <ul class="complementary-products__list list-unstyled grid grid--2-col-tablet grid--4-col-desktop">
            ${data.products
              .map((p) => {
                const image =
                  (p.featured_image?.startsWith('//') ? 'https:' : '') +
                  (p.featured_image || '');
                const price = p.price ? `$${(p.price / 100).toFixed(2)}` : '';
                return `
                  <li class="complementary-card grid__item">
                    <a href="${p.url}" class="complementary-card__link">
                      <img src="${image}" alt="${p.title}" loading="lazy"/>
                      <h3>${p.title}</h3>
                      
                    </a>
                  </li>`;
              })
              .join('')}
          </ul>
        </div>
      </details>
    </div>
  </aside>
`;


       
      })
      .catch((err) => console.error('💥 Error fetching recommendations:', err));
  });
});
